import React from 'react';
import { Table, Button, Container, Spinner, Alert } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';
import {
  useGetInformationsQuery,
  useDeleteInformationMutation,
} from '../slices/informationApiSlice'; // Adjust path if needed

const InformationListScreen = () => {
  const {
    data: informations,
    isLoading,
    error,
    refetch,
  } = useGetInformationsQuery();

  const [deleteInformation, { isLoading: loadingDelete }] = useDeleteInformationMutation();

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this information?')) {
      try {
        await deleteInformation(id).unwrap();
        refetch(); // Refresh the list
      } catch (err) {
        console.error('Delete failed:', err);
        alert('Failed to delete information');
      }
    }
  };

  return (
    <Container className="py-5">
      <h2 className="mb-4 text-center">Information List</h2>

      {loadingDelete && (
        <div className="mb-3">
          <Spinner animation="border" size="sm" className="me-2" />
          Deleting information...
        </div>
      )}

      {isLoading ? (
        <div className="text-center">
          <Spinner animation="border" />
        </div>
      ) : error ? (
        <Alert variant="danger">
          {error?.data?.message || 'Failed to fetch information'}
        </Alert>
      ) : (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Information</th>
              <th>Created At</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {informations.map((info) => (
              <tr key={info._id}>
                <td>{info.information}</td>
                <td>{new Date(info.createdAt).toLocaleString()}</td>
                <td className="text-center">
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => handleDelete(info._id)}
                  >
                    <FaTrash className="me-1" />
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </Container>
  );
};

export default InformationListScreen;
